import { createFileRoute } from "@tanstack/react-router";
import { EditContent, EditDomain } from "@/features/consent-solutions";

const Route = createFileRoute("/_authorized/consent-solutions/$csId/domains/$domainId/")({
  component: () => (
    <EditContent>
      <EditDomain />
    </EditContent>
  ),
});

export { Route };
